<template>
  <div id="switch-trip">
    <div class="buisness-travel df-jsb-aic" :class="{ 'mt2': !isPhone }">
      <h3 class="raleway-semi-p13 mb-0">Gare à proximité <span v-if="getFilterCount('station')" class="filter-count">({{ getFilterCount('station') }})</span></h3>
      <input type="checkbox" id="Gare à proximité" :value="67" v-model="selected" /><label for="Gare à proximité">Gare à proximité</label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'switch-station',
  props: ['filterCounts'],
  data() {
    return {
      selected: [],
    };
  },
  methods: {
    getFilterCount(filterType) {
      if (!this.filterCounts || !this.filterCounts.service_ids) return 0;
      const serviceData = this.filterCounts.service_ids.find(s => s.key === 67);
      return serviceData ? serviceData.count : 0;
    },
  },
  watch: {
    selected(val) {
      // easier to handle only arrays
      this.$emit('checked', val, 'eq_services');
    },
  },
  computed: {
    isPhone() {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)) {
        return true;
      } else {
        return false;
      }
    },
  }
};
</script>

<style lang="scss" scope="app/assets/stylesheets/components/lodging-filter">
.filter-count {
  color: #666;
  font-size: 0.9em;
  font-weight: normal;
  margin-left: 4px;
}
</style>
